import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Analytics from './../../analytics';
import UserLoginButton from './../ui/userLoginButton';
import {toggleUserPopup, changeMessageBoxState, showSchedulerPopup} from "../../actions/actionFunctions";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {saveQuote} from "../../api/server-api";
import {QuoteRequestType, UserPopupTypes} from "../visComponents/constants";
import {renderMessagePopup} from "../../api/api-popups";

class ScheduleButton extends Component {

  static propTypes = {
    buttonLayoutId: PropTypes.oneOf(["mobileButton", "designButtonMenu", "mobileNavigationMenu"]).isRequired,
    scheduleButtonOnClick: PropTypes.func
  };

  handleScheduleButtonClick = () => {
    if (this.props.scheduleButtonOnClick) {
      this.props.scheduleButtonOnClick(); // close design button list, etc.
    }
    const fabricatorSettings = this.props.fabricatorSettings;
    Analytics.sendClickEvent(this.getAnalyticsEvent());
    if (!this.props.isPhoneNumberValidated) {
      UserLoginButton.handleLoginClick({
        ...this.props,
        userPopupType: UserPopupTypes.Schedule
      });
      return;
    }
    if (fabricatorSettings.enableCalendarForScheduling) {
      this.props.showSchedulerPopup(true)
    } else {
      loaderEnable("loader.appointmentText", "loader.appointmentTitle");
      saveQuote({submit: true, quoteRequestType: QuoteRequestType.ScheduleAnAppointment})
        .then(() => {
          loaderDisable();
          renderMessagePopup("userPopup.messageBox.appointmentRequested");
        });
    }
  };

  getAnalyticsEvent = () => {
    switch (this.props.buttonLayoutId) {
      case "mobileButton":
      default:
        return "schedule-appointment-main-button";
      case "designButtonMenu":
        return "design-buttons-schedule-button";
      case "mobileNavigationMenu":
        return "menu-option-clicked-design-consultation";
    }
  };

  getSchedulingButton =() => {
    switch (this.props.buttonLayoutId) {
      case "mobileButton":
      default:
        return (
          <button className="mobilebutton mobilebutton--schedule"
                  onClick={this.handleScheduleButtonClick}>
            <span className="mobilebutton-text mobilebutton-text--schedule"><FormattedMessage id="scheduleButton"/></span>
          </button>
        );
      case "designButtonMenu":
        return (
          <li className="des-list__item">
            <button className="mobilebutton mobilebutton--schedule"
                    onClick={this.handleScheduleButtonClick}>
              <span className="mobilebutton-text mobilebutton-text--schedule"><FormattedMessage id="scheduleButton"/></span>
            </button>
          </li>
        );
      case "mobileNavigationMenu":
        return (
          <li className="menu-dropdown__list-item menu-dropdown__list-item--schedule"
              onClick={this.handleScheduleButtonClick}><FormattedMessage id="mobileMenu.scheduleButton"/></li>
        )
    }
  };

  render() {
    return this.props.fabricatorSettings.enableScheduling ? this.getSchedulingButton() : null
  }

}
const mapStateToProps = (store) => ({
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  fabricatorSettings: store.fabricatorState.settings
});
export default connect(mapStateToProps, {
  toggleUserPopup,
  changeMessageBoxState,
  showSchedulerPopup
})(ScheduleButton);
